import { useTheme } from "@emotion/react";
import { Button, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CenteredText from "components/CenteredText";
import Page from "components/Page";

import AreaXLogo from "assets/images/areax_logo.svg";
import ICLogo from "assets/images/ic_logo.svg";
import Checkbox from "@mui/material/Checkbox";
import { Link } from "react-router-dom";
import { useState } from "react";

const defaultFields = (company) => {
	return {
		subject: `Richiesta di iscrizione alle iniziative di ${company.name}`,
		body: `Dichiaro di voler essere ricontattato per conoscere le iniziative di ${company.name}.

Sono informato che posso richiedere la cancellazione della mia email dalla lista dei destinatari delle vostre iniziative inviando una mail a ${company.email}`
	};
};

const defs = {
	areax: {
		logo: {
			src: AreaXLogo,
			style: {width: "50%"}
		},
		informativa: "https://firebasestorage.googleapis.com/v0/b/pyramid-ce957.appspot.com/o/areax%2FNewsletter%20Area%20X_InformativaPrivacyV2.pdf?alt=media&token=b94c6676-54aa-45e8-945b-99734bdcbc3e",
		mail: "segreteria@areax.info",
		...defaultFields({name: "Area X", email: "segreteria@areax.info", responsabile: "Area X"}),
		redirect: {
			url: "/scopri_areax",
			text: "Torna a “Scopri Area X”"
		}
	},
	ic: {
		logo: {
			src: ICLogo,
			style: {width: "90%"}
		},
		informativa: "https://www.intesasanpaoloinnovationcenter.com/downloads/Informativa%20e%20Consensi%20Privacy%20Intesa%20Sanpaolo%20Innovation%20Center.pdf",
		mail: "sharinginnovation@intesasanpaolo.com",
		...defaultFields({
			name: "Intesa Sanpaolo Innovation Center",
			email: "sharinginnovation@intesasanpaolo.com",
			responsabile: "Intesa Sanpaolo Innovation Center"
		}),
		redirect: {
			url: "/scopri_ic",
			text: "Torna a “Scopri Innovation Experience”"
		}
	}
};

const Contatti = ({company}) => {
	const theme = useTheme();
	const [checked, setChecked] = useState(false);
	console.log(company, `mailto:${defs[company].mail}?subject=${defs[company].subject}&body=${defs[company].body}`);
	const handleChange = (event) => {
		setChecked(event.target.checked);
	};

	return (
		<Page bg={theme.palette.background.paper}>
			<Stack spacing={2} sx={{
				display: "flex",
				flex: 1
			}}>
				<CenteredText>
					<Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
						<img src={defs[company].logo.src} alt="AreaX" style={defs[company].logo.style}/>
					</Box>
				</CenteredText>
				<CenteredText>
					<Typography variant="h5" sx={{paddingInline: "1.1rem", lineHeight: "2rem", fontWeight: "bold"}}>
						Rimani in contatto con noi
					</Typography>
				</CenteredText>
				<Box sx={{
					flex: 1,
					flexDirection: "column",
					display: "flex", justifyContent: "center", alignContent: "center"
				}}>


					<Box>
						<CenteredText sx={{paddingInline: "2rem", color: theme.palette.white.main}}>
							<Typography variant="h5" sx={{lineHeight: "2.5rem"}}>
								Scrivici una mail per rimanere aggiornato sulle novità!
							</Typography>

							<Checkbox label={"Ho preso visione dell'"} color="white"
												checked={checked}
												onChange={handleChange}
							/>
							<Typography variant="body"
													sx={{textDecoration: "none"}}
													color="white">
								Ho preso visione dell'<a
								target="_blank"
								style={{textDecoration: "underline", color: theme.palette.white.main}}
								href={defs[company].informativa} rel="noreferrer"
							>
								Informativa Privacy
							</a>
							</Typography>
						</CenteredText>
						<CenteredText>
							<Typography variant="h5" sx={{paddingInline: "2rem"}}>
								<Button variant="contained" size="small" role="link" disabled={!checked}
												target="_blank"
												href={`mailto:${defs[company].mail}?subject=${defs[company].subject}&body=${encodeURIComponent(defs[company].body)}`}
												sx={{backgroundColor: theme.palette.primary.light}}>
									Invia
								</Button>
							</Typography>
						</CenteredText>
					</Box>
				</Box>
				<CenteredText style={{flex: 0.3}}>
					<Link to={defs[company].redirect.url}>
						<Typography variant="h6"
												color={theme.palette.white.main}
												sx={{textDecoration: "underline"}}>
							{defs[company].redirect.text}
						</Typography>
					</Link>
				</CenteredText>
			</Stack>
		</Page>
	);
};

export default Contatti;